import { apiClient } from "@api/apiClient";

import { DefaultPressClassificationResponseData } from "./pressClassification.interface";

const API_ENDPOINT = "des/draft-article/classification/";

export const pressClassificationApi = {
  getPressClassificationData: async () => {
    const response =
      await apiClient.get<DefaultPressClassificationResponseData>(
        `${API_ENDPOINT}`,
      );

    return response.data;
  },
};
